var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('portal',{attrs:{"to":"app-header"}},[_c('router-link',{staticClass:"mr-2",attrs:{"to":"/particlesjs/demo1"}},[_vm._v(" go demo1 ")]),_c('router-link',{staticClass:"mr-2",attrs:{"to":"/particlesjs/demo2"}},[_vm._v(" go demo2 ")])],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }